module.exports = __webpack_public_path__ + "static/media/mindfulness-large@2x.34db1e11.png";